import React from 'react';
import { StyledBox, StyledCard } from '../BenevvPopup.styles';
import { Typography } from '@mui/material';

interface BenevvPopupPosterProps {
  image: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const BenevvPopupPoster = ({ image, description, selected, onClick }: BenevvPopupPosterProps) => (
  <StyledCard selected={selected} onClick={onClick} sx={{ height: 'auto', flexDirection: 'column', padding: '1.5rem 0.5rem 0.5rem 0.5rem', }}>
    <img src={image} alt="Poster" style={{ width: '100%' }} />
    <Typography sx={{fontSize: '12px', paddingTop: 1, alignSelf: 'flex-start'}}>{description}</Typography>
    <StyledBox selected={selected} />
  </StyledCard>
);

export default BenevvPopupPoster;
